import { Hammer } from "lucide-react";

export default function Maintenance() {
  return (
    <div
      data-testid="maintenance-page"
      className="min-h-screen flex items-center justify-center bg-[#E0F2F1] px-6 py-20 grain relative overflow-hidden"
    >
      {/* Decorative soft copper glow */}
      <div
        aria-hidden="true"
        className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-[#B87333]/10 blur-3xl pointer-events-none"
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#00BFA5]/10 blur-3xl pointer-events-none"
      />

      <div className="text-center max-w-2xl relative">
        {/* Copper hammer icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white border-2 border-[#B87333]/40 shadow-sm mb-8">
          <Hammer className="text-[#B87333]" size={30} strokeWidth={2.2} />
        </div>

        <p className="smallcaps mb-6 tracking-[0.35em]">The Workshop</p>

        <h1 className="font-display font-black !text-[#B87333] text-5xl sm:text-6xl md:text-7xl mb-6 leading-[1.05]">
          David&apos;s Chopping Boards
        </h1>

        {/* Copper hairline divider */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <span className="h-px w-16 bg-[#B87333]/50" />
          <span className="w-2 h-2 rounded-full bg-[#B87333]" />
          <span className="h-px w-16 bg-[#B87333]/50" />
        </div>

        <p className="text-[#212121] font-medium text-lg sm:text-xl leading-relaxed mb-4">
          We&apos;re currently busy in the workshop.
        </p>
        <p className="text-[#212121] font-medium text-lg sm:text-xl leading-relaxed">
          The shop will be open for business very soon.
        </p>

        <p className="mt-10 text-sm text-[#757575] tracking-widest uppercase">
          Handcrafted &nbsp;·&nbsp; Invercargill, NZ
        </p>
      </div>
    </div>
  );
}
